import { AuthorityType } from './../../model/user/authority-type.enum';
import { HeaderService } from '../../component/header/header.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NecTenantInterface } from './tenant.interface';
import { Observable } from 'rxjs';
import { Tenant } from './../../model/tenant/tenant';
import { TenantNameDto } from './../../model/tenant/tenant-name-dto';
import { UserService } from './../user/user.service';



@Injectable()
export class NecTenantService {
  constructor(private necTenantInterface: NecTenantInterface,
    private userService: UserService,
    private headerService: HeaderService) {

  }


  /**
   * æ¥è¯¢å»é¢ä¿¡æ¯
   * @param tenantId å»é¢id
   * @param type  ç±»å admin ç®¡çåæ¥è¯¢ user ç¨æ·æ¥è¯¢
   */
  getTenant(): Observable<Tenant> {
    let tenant: Tenant = this.userService.getTenant();
    let tenantId: number = this.userService.getTenantId();
    let auth: AuthorityType = this.userService.getAuthority();

    if (tenant && tenant.logo && tenant.pictures && (!tenant.pictures.length || tenant.pictures[0].mediaInfo.url)) {
      return Observable.create(observer => {
        observer.next(tenant);
        observer.complete();
      });
    } else {
      let userInfo = this.userService.getUserInfo();
      return this.necTenantInterface.getTenant(tenantId, auth === AuthorityType.ROLE_TENANT ? 'admin' : 'user')
        .pipe(map(data => {
          tenant.logo = data.logo;
          tenant.pictures = data.pictures;
          if (auth === AuthorityType.ROLE_TENANT) {
            userInfo.me = tenant;
          } else {
            userInfo.tenant = tenant;
          }
          this.userService.setUserInfo(userInfo);
          this.headerService.updateInfo();
          return tenant;
        }));
    }
  }

  /**
   * å»é¢æç´¢
   */
  getTenantsByName(tenantName: string): Observable<TenantNameDto[]> {
    return this.necTenantInterface.getTenantsByName(tenantName);
  }
}
